import axios from "axios";
import { defaultConfig } from "../config";
import { removeAuth } from "../helpers/Index";

const axiosInt = axios.create({
  baseURL: defaultConfig.baseAPIUrl,
});

axiosInt.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      removeAuth();
      window.location.href = `/`;
    }
    if (error?.response?.status === 403) {
      window.location.href = "/dashboard";
    } 
  }
);

export default axiosInt;
